import type { BoxProps } from '@chakra-ui/react';
import { Box, Text } from '@chakra-ui/react';
import React from 'react';

interface MessageContainerProps extends BoxProps {
  children: React.ReactNode;
  time: string;
  isSelf: boolean;
}

/**
 * A reusable container component for all message types.
 * Handles timestamp display and provides a base container.
 */
const MessageContainer: React.FC<MessageContainerProps> = ({ children, time, isSelf, ...rest }) => {
  return (
    <Box {...rest}>
      {children}

      {time && (
        <Text
          fontSize="xs"
          color={isSelf ? 'white' : 'gray.500'}
          textAlign="left"
          mt={1}
          opacity={0.8}
        >
          {time}
        </Text>
      )}
    </Box>
  );
};

export default MessageContainer;
